//Angle conversion
//Angle conversion
//Angle conversion
function degToRad(deg) {
  return (Math.PI * deg) / 180;
}

function radToDeg(rad) {
  return (rad * 180) / Math.PI;
}

function pointInsideRect(rect, x, y) {
  var rx = rect.x;
  var ry = rect.y;
  if (rect.anchor) {
    rx = rect.x - rect.anchor.x * rect.width;
    ry = rect.y - rect.anchor.y * rect.height;
  }
  return x > rx && x < rx + rect.width && y > ry && y < ry + rect.height;
}

function saveObject(name, obj) {
  if (localStorage) localStorage.setItem(name, JSON.stringify(obj));
}

function loadObject(name) {
  if (localStorage) return JSON.parse(localStorage.getItem(name));

  return null;
}

// TEXT TRUNCATE  ***************** *****************
// TEXT TRUNCATE  ***************** *****************
// TEXT TRUNCATE  ***************** *****************
function textTruncate(string, maxLength, upperCase) {
  var corected_string = string;
  if (upperCase) {
    corected_string = corected_string.toUpperCase();
  } else {
    corected_string = corected_string.charAt(0).toUpperCase() + corected_string.slice(1);
  }

  if (maxLength == undefined) {
    return corected_string;
  } else if (corected_string.length > maxLength) {
    return corected_string.substr(0, maxLength - 3) + "...";
  } else {
    return corected_string;
  }
}

// TRY TO SET TEXT ***************** *****************
// TRY TO SET TEXT ***************** *****************
// TRY TO SET TEXT ***************** *****************
function trySetText(el, text) {
  if (el != undefined) {
    el.setText(text);
  }
}

// FORMAT NUMBERS ***************** *****************
// FORMAT NUMBERS ***************** *****************
// FORMAT NUMBERS ***************** *****************
function numberWithCommas(num, addCurrency) {
  addCurrency = addCurrency || true;
  var parts;
  if (num < 0.01) {
    parts = myFixed(num, 4).split(".");
  } else {
    parts = myFixed(num, 2).split(".");
  }

  function myFixed(num, d) {
    if (!d) return num.toFixed(d); // don't go wrong if no decimal
    return Math.abs(num)
      .toFixed(d)
      .replace(/\.?0+$/, "");
  }
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (!addCurrency) {
    return parts.join(".");
  } else {
    return parts.join(".") + " " + currency_str;
  }
}

function numberWithDecimal(val) {
  return Math.abs(Number(val.toFixed(6)));
}

var fpsText;

function showFPS(color, anchorX, anchorY) {
  anchorX = anchorX || 0;
  anchorY = anchorY || 0;
  color = color || 0x000000;
  var al = "center";
  if (anchorX < 0.1) al = "left";
  if (anchorX > 0.9) al = "right";
  ts = new PIXI.TextStyle({
    fontSize: 12,
    fill: [color],
    align: al,
  });
  fpsText = new Text(APP.stage, "", ts);
  fpsText.x = APP.screen.width * anchorX;
  fpsText.y = APP.screen.height * anchorY;
  fpsText.anchor.set(anchorX, anchorY);
  fpsText.interval = setInterval(function () {
    fpsText.text = Math.round(APP.ticker.FPS);
  }, 100);
}

function hideFPS() {
  clearInterval(fpsText.interval);
  fpsText.delete();
  fpsText = undefined;
}

var logText;

function showLog(text, color, anchorX, anchorY) {
  if (logText == undefined) {
    color = color || 0x000000;
    var al = "center";
    if (anchorX < 0.1) al = "left";
    if (anchorX > 0.9) al = "right";
    ts = new PIXI.TextStyle({
      fontSize: 12,
      fill: [color],
      align: al,
    });
    logText = new Text(APP.stage, "", ts);
    logText.x = 0;
    logText.y = 0;
    logText.anchor.set(0);
  }
  if (anchorX != undefined && anchorY != undefined) {
    logText.x = APP.screen.width * anchorX;
    logText.y = APP.screen.height * anchorY;
    logText.anchor.set(anchorX, anchorY);
  }

  logText.text += "\n" + text;
}

function clearLog() {
  logText.text = 0;
}

function hideLog() {
  logText.delete();
  logText = undefined;
}

function logErrors() {
  window.onerror = function (msg, url, line, col, error) {
    showLog(msg, 0xff0000, 1, 1);
  };
}

function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }
  return os;
}

//parse time
function parseTime(timeString) {
  var arr = timeString.split(/[\-\+ :T]/);
  var time = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
  var min = time.getMinutes();
  if (min < 10) {
    min = "0" + min;
  }
  var hour = time.getHours();
  if (hour < 10) {
    hour = "0" + hour;
  }
  var date = time.getDate();
  if (date < 10) {
    date = "0" + date;
  }
  var month = time.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  return hour + ":" + min + " " + date + "." + month + "." + time.getFullYear();
}

function milliToMMSS(milli) {
  var sec = Math.floor((milli / 1000) % 60);
  if (sec < 10) {
    sec = "0" + sec;
  }
  var min = Math.floor((milli / (60 * 1000)) % 60);
  if (min < 10) {
    min = "0" + min;
  }

  return min + ":" + sec;
}

//random integer 0-a or a-b required:a; optional b(def: 0);
function random(a, b) {
  var b = b || 0;
  return Math.round(a + Math.floor(Math.random() * (b - a)));
}

function randomColor() {
  return random(0xffffff);
}

//random element from array - required: array; optional: removeElement(def: false), probabilityProp(if elements have different probability to be drawn)
function randomElement(array, removeElement, probabilities) {
  removeElement = removeElement || false;
  if (probabilities) {
    var s = 0;
    rand = Math.random();
    var probabilityProp = typeof probabilities == "string";
    for (var i = 0; i < array.length; i++) {
      if (probabilityProp) {
        s += array[i][probabilities];
      } else {
        s += probabilities[i];
      }
      if (rand < s || i == array.length - 1) {
        var el = array[i];
        if (removeElement) {
          array.splice(i, 1);
          if (!probabilityProp) {
            var chosenProb = probabilities[i];
            probabilities.splice(i, 1);
          }
          for (var j = 0; j < array.length; j++) {
            if (probabilityProp) {
              array[j][probabilities] *= 1 / (1 - el[probabilities]);
            } else {
              probabilities[j] *= 1 / (1 - chosenProb);
            }
          }
        }
        return el;
      }
    }
  } else {
    var randIndex = random(array.length);
    var el = array[randIndex];
    if (removeElement) {
      array.splice(randIndex, 1);
    }
    return el;
  }
}

//pseudorandom
var prevRandSeed;

function resetPseudoRandom() {
  prevRandSeed = Math.E;
}

function pseudoRandom(seed) {
  seed = Math.abs(seed / Math.E) + prevRandSeed;
  prevRandSeed = seed + Math.E;
  return seed - Math.floor(seed);
}
resetPseudoRandom();
//var check=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
//for (var i=0;i<100;i++)
//{
//    check[Math.floor(pseudoRandom(1)*20)]++;
//}
//console.log(check);

//shuffles an array
function shuffleArray(array) {
  var len = array.length;
  for (var i = len - 1; i > 0; i--) {
    var rand = random(i + 1);
    var p = array[i];
    array[i] = array[rand];
    array[rand] = p;
  }
}

function pushElements(array, element, copies) {
  for (var i = 0; i < copies; i++) {
    array.push(element);
  }
}

function unshiftElements(array, element, copies) {
  for (var i = 0; i < copies; i++) {
    array.unshift(element);
  }
}

var coorStart = {
  x: 0,
  y: 0,
  z: 0,
};

function distance(a, b) {
  if (b == undefined) b = coorStart;

  if (a.z == undefined) {
    return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y));
  } else {
    return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y) + (a.z - b.z) * (a.z - b.z));
  }
}

function isChrome() {
  var isChromium = window.chrome,
    winNav = window.navigator,
    vendorName = winNav.vendor,
    isOpera = winNav.userAgent.indexOf("OPR") > -1,
    isIEedge = winNav.userAgent.indexOf("Edge") > -1,
    isIOSChrome = winNav.userAgent.match("CriOS");

  if (isIOSChrome) {
    return true;
  } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
    return true;
  } else {
    return false;
  }
}

var hidden, visibilityChange;
if (typeof document.hidden !== "undefined") {
  hidden = "hidden";
  visibilityChange = "visibilitychange";
} else if (typeof document.mozHidden !== "undefined") {
  hidden = "mozHidden";
  visibilityChange = "mozvisibilitychange";
} else if (typeof document.msHidden !== "undefined") {
  hidden = "msHidden";
  visibilityChange = "msvisibilitychange";
} else if (typeof document.webkitHidden !== "undefined") {
  hidden = "webkitHidden";
  visibilityChange = "webkitvisibilitychange";
}

if (!window.console) {
  window.console = {};
}
if (!window.console.log) {
  window.console.log = function () {};
}

// FULL SCREEN TOGGLE **************************************
// FULL SCREEN TOGGLE **************************************
// FULL SCREEN TOGGLE **************************************
var fullScreenSupported = false;
try {
  if (Modernizr.fullscreen) {
    fullScreenSupported = true;
  } else {
    fullScreenSupported = false;
  }
} catch (e) {}

function toggleFullScreen() {
  if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  } else {
    element = $("body").get(0);
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }
}

function isFullScreen() {
  return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
}

//activate all buttons in a given container
//optional: parent (def: stage), recursive (activates children's children, def: true)
function enableAllButtons(parent, recursive) {
  parent = parent || APP.stage;
  recursive = recursive || true;
  for (var i = 0; i < parent.children.length; i++) {
    if (parent.children[i].type == "Button") {
      parent.children[i].prevState = parent.children[i].interactive;
      parent.children[i].enable();
    } else if (recursive && parent.children[i].type == "Container") {
      enableAllButtons(parent.children[i], true);
    }
  }
}

//deactivate all buttons in a given container
//optional: parent (def: stage), recursive (deactivates children's children, def: true)
function disableAllButtons(parent, recursive) {
  parent = parent || APP.stage;
  recursive = recursive || true;
  for (var i = 0; i < parent.children.length; i++) {
    if (parent.children[i].type == "Button") {
      parent.children[i].prevState = parent.children[i].interactive;
      parent.children[i].disable();
    } else if (recursive && parent.children[i].type == "Container") {
      disableAllButtons(parent.children[i], true);
    }
  }
}

//deactivate all buttons in a given container
//optional: parent (def: stage), recursive (resets children's children, def: true)
function resetAllButtons(parent, recursive) {
  parent = parent || APP.stage;
  recursive = recursive || true;
  for (var i = 0; i < parent.children.length; i++) {
    if (parent.children[i].type == "Button") {
      if (parent.children[i].prevState) {
        parent.children[i].enable();
      } else {
        parent.children[i].disable();
      }
    } else if (recursive && parent.children[i].type == "Container") {
      resetAllButtons(parent.children[i], true);
    }
  }
}

function clickLog(parent, recursive) {
  parent = parent || APP.stage;
  recursive = recursive || true;
  parent.clickLogEnabled = parent.clickLogEnabled || false;

  for (var i = 0; i < parent.children.length; i++) {
    if (parent.children[i].type != "Container") {
      if (!parent.clickLogEnabled) {
        parent.children[i].oldInteractive = parent.children[i].interactive;
        parent.children[i].interactive = true;
        parent.children[i].on("pointerup", objectLog);
      } else {
        parent.children[i].interactive = parent.children[i].oldInteractive;
        parent.children[i].off("pointerup", objectLog);
      }
    } else if (recursive) {
      clickLog(parent.children[i], true);
    }
  }

  parent.clickLogEnabled = !parent.clickLogEnabled;

  if (parent.clickLogEnabled) {
    return "Click log enabled.";
  } else {
    return "Click log disabled.";
  }
}

function objectLog(e) {
  if (this.loggingActive) {
    return;
  }
  if (this.oldAlpha == undefined) {
    this.oldAlpha = this.alpha;
  }
  for (var i = 0; i < 10; i++) {
    setTimeout(
      function (o, a) {
        o.loggingActive = true;
        o.alpha = a;
      },
      i * 200,
      this,
      i % 2
    );
  }
  setTimeout(
    function (o) {
      o.loggingActive = false;
      o.alpha = o.oldAlpha;
      o.oldAlpha = undefined;
    },
    2000,
    this
  );
  console.log("---CLICK LOG---");
  if (this.getName != undefined) {
    console.log(this.getName());
  }
  console.log(this);
  console.log("---------------");
}

function drawGuideLines(color) {
  color = color || 0x00ff00;
  APP.stage.guideLines = [];
  var w = APP.screen.width;
  var h = APP.screen.height;

  APP.stage.guideLinesContainer = new Container(APP.stage);
  APP.stage.guideLinesContainer.color = color;
  APP.stage.hGuideLines = [];
  APP.stage.vGuideLines = [];
  for (var i = -10; i < (h + 100) / 10; i++) {
    APP.stage.hGuideLines[i] = new WhiteRectangle(APP.stage.guideLinesContainer, [w, 1], color);
    APP.stage.hGuideLines[i].alpha = 0.1;
    if (i % 5 == 0) APP.stage.hGuideLines[i].alpha = 0.25;
    if (i % 10 == 0) APP.stage.hGuideLines[i].alpha = 0.5;

    APP.stage.hGuideLines[i].setTransform(w / 2, i * 10 + (h % 100) / 2);
  }

  for (var i = -10; i < (w + 100) / 10; i++) {
    APP.stage.vGuideLines[i] = new WhiteRectangle(APP.stage.guideLinesContainer, [1, h], color);
    APP.stage.vGuideLines[i].alpha = 0.1;
    if (i % 5 == 0) APP.stage.vGuideLines[i].alpha = 0.25;
    if (i % 10 == 0) APP.stage.vGuideLines[i].alpha = 0.5;

    APP.stage.vGuideLines[i].setTransform(i * 10 + (w % 100) / 2, h / 2);
  }

  var hCenter = new WhiteRectangle(APP.stage.guideLinesContainer, [2, h], color);
  hCenter.alpha = 0.5;
  hCenter.setTransform(w / 2, h / 2);
  var vCenter = new WhiteRectangle(APP.stage.guideLinesContainer, [w, 2], color);
  vCenter.alpha = 0.5;
  vCenter.setTransform(w / 2, h / 2);

  APP.stage.guideLinesContainer.resize = function () {
    var color = APP.stage.guideLinesContainer.color;
    clearGuideLines();
    drawGuideLines(color);
  };
  resize_methods.push(APP.stage.guideLinesContainer.resize);
}

function clearGuideLines() {
  if (APP.stage.guideLinesContainer) {
    resize_methods.splice(resize_methods.indexOf(APP.stage.guideLinesContainer.resize), 1);
    APP.stage.guideLinesContainer.resize = null;
    APP.stage.guideLinesContainer.delete();
    APP.stage.hGuideLines = null;
    APP.stage.vGuideLines = null;
  }
}

//shakes the entire screen
//optional: container(def: APP.stage)
function shakeScreen(power, duration, container) {
  container = container || APP.stage;
  if (container.posBeforeShake == undefined) {
    container.posBeforeShake = {
      x: container.x,
      y: container.y,
    };
  } else {
    for (var i = 0; i < container.shakeTimeouts.length; i++) {
      clearTimeout(container.shakeTimeouts[i]);
    }
  }
  container.shakeTimeouts = [];
  for (var i = 0; i < duration; i += 30) {
    container.shakeTimeouts.push(
      setTimeout(
        function (c) {
          c.x = container.posBeforeShake.x + random(-power / 2, power / 2);
          c.y = container.posBeforeShake.y + random(-power / 2, power / 2);
        },
        i,
        container
      )
    );
  }

  container.shakeTimeouts.push(
    setTimeout(
      function (c) {
        c.position.set(c.posBeforeShake.x, c.posBeforeShake.y);
        c.posBeforeShake = undefined;
        container.shakeTimeouts = undefined;
      },
      duration,
      container
    )
  );
}

function countText(textObject, start, end, duration, soundNames) {
  var parts = duration / 30;
  textObject.oldPlayCountValue = start;
  for (var i = 0; i < parts; i++) {
    setTimeout(
      function (t, n, s, p) {
        if (t) {
          t.text = n;
          if (s && p && t.oldPlayCountValue != n) {
            playSound(randomElement(s));
            t.oldPlayCountValue = n;
          }
        }
      },
      i * 30,
      textObject,
      Math.round(start + ((i + 1) * (end - start)) / parts),
      soundNames,
      i % 3 == 0
    );
  }
}

function makeInteractive(obj, eventName, callback) {
  obj.interactive = true;
  obj.buttonMode = true;
  obj.on(eventName, callback);
}

//capture screen
//fali crop
function captureScreen(x, y, width, height) {
  x = x || 0;
  y = y || 0;
  width = width || APP.screen.width;
  height = height || APP.screen.height;
  APP.renderer.preserveDrawingBuffer = true;
  APP.renderer.render(APP.stage);
  dataURL = APP.view.toDataURL("image/png", 1);
  APP.renderer.preserveDrawingBuffer = false;

  return dataURL;
}

//check internet connection
function isConnected() {
  //    if (window.JSInterface)
  //            return (window.JSInterface.isConnected()=="true")
  //    else
  return is.online();
}
